'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import { useHubSpotConversationsWidget } from '@workspace/ui/hooks';
import { getHubSpotPortalId } from '@workspace/ui/lib';
import { useAuthStore } from '@/stores/authStore';

export const HUBSPOT_SHOW_CHAT_BUTTON_PATHS = [
  '/company-verification',
  '/add-employee',
  '/add-money',
  '/send-money',
];

export default function HubSpotChat() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const email = useAuthStore((state) => state.user?.user?.email ?? null);
  const portalId = getHubSpotPortalId();

  useHubSpotConversationsWidget({
    isEnabled: isAuthenticated && Boolean(portalId),
    email,
  });

  return null;
}
